// 创建一个遮罩层，用于强调特定的页面元素，并阻止用户进行其他操作。
import type { ComponentInterface, EventEmitter } from '@stencil/core';
import { Component, Host, h, Prop, Event } from '@stencil/core';

@Component({
  tag: 'jackery-overlay',
  styleUrl: 'jackery-overlay.css',
  shadow: true
})
export class JackeryOverlay implements ComponentInterface {
  /**
   * 控制遮罩层是否显示
   */
  @Prop({mutable: true}) open = false;

  /**
   * 弹窗内容容器尺寸：
   * `"sm"`: PC: 480px. MB: 74.6VW
   * `"md"`: PC: 660px. MB: 85.3VW
   * `"lg"`: PC: 880px. MB: 100VW
   */
  @Prop() size: 'sm' | 'md' | 'lg' = 'md';

  /**
   * 遮罩层级
   */
  @Prop() zindex: number = 999;

  /**
   * 点击遮罩触发关闭
   */
  @Prop() closeable: boolean = true;

  /**
   * 遮罩关闭触发
   */
  @Event() jkyClose!: EventEmitter<void>;
  

  handleMaskClick = () => {
    if(!this.closeable) return
    this.jkyClose.emit();
    this.open = false
  }

  render() {
    return (
      <Host
        style={{
          "--overlay-z-index": `${this.zindex}`
        }}
        class={{
          [`overlay-open-${this.open}`]: true,
          [`overlay-size-${this.size}`]: true,
        }}
      >
        <div
          class="jackery-overlay" 
          part="overlay"
        >
          <div class="container">
            <slot />
          </div>
        </div>
        <div
          class="quark-overlay-mask"
          part="mask"
          onClick={() => this.handleMaskClick()}
        />
      </Host>
    );
  }
}
